enum ROUTES {
  DASHBOARD = '/dashboard',
}

export default ROUTES;
